<div class="flex-row align-items-center white-bg">
  <ts-search-bar
    class="flex-grow-1"
    [searchValue]="searchValue"
    (searchChanged)="searchChanged.emit($event)"
  ></ts-search-bar>

  <ts-token-paginator
    [previousTokens]="previousTokens"
    [lastItem]="lastItem"
    [counting]="counting"
    [length]="length"
    [pageSize]="pageSize"
    [hidePageSize]="false"
    [pageSizeOptions]="pageSizeOptions"
    [disabled]="disabled"
    (pageChange)="pageChange.emit($event)"
    (pageSizeChange)="pageSizeChange.emit($event)"
    style="margin-left: 16px"
  ></ts-token-paginator>
</div>
